import { createClient } from '@supabase/supabase-js'
import { Database } from '../types/database'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

console.log('=== Supabase Environment Variables Debug ===')
console.log('REACT_APP_SUPABASE_URL:', supabaseUrl)
console.log('REACT_APP_SUPABASE_URL type:', typeof supabaseUrl)
console.log('REACT_APP_SUPABASE_URL length:', supabaseUrl?.length)
console.log('REACT_APP_SUPABASE_ANON_KEY exists:', !!supabaseAnonKey)
console.log('REACT_APP_SUPABASE_ANON_KEY type:', typeof supabaseAnonKey)
console.log('All REACT_APP env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')))
console.log('==========================================')

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Make sure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY are set in your .env file.'
  )
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)